import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-services-filter--hide{
    animation: exiting 0.5s forwards;
  }
`

export const ModalContainer = styled.article`
  width: 95%;
  max-width: 486px;
  height: 371px;
  max-height: 99vh;
  padding: 85px 0 46px;

  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: 17px;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);

  .modal-services-filter__title{
    width: 95%;
    margin: 0 auto;

    display: inline-block;

    color: var(--blue00);
    font-size: 1.6875rem;
    text-align: center;
  }

  .modal-services-filter__select{
    width: 95%;
    max-width: 324px;
    margin: 0 auto;

    box-shadow: 0 3px 6px rgba(0,0, 0, 0.19);
  }

  .modal-services-filter__button{
    width: 95%;
    max-width: 412px;
    height: 57px;
    margin: 0 auto;

    border-radius: 59px;
    border: 0;
    outline: none;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    cursor: pointer;
    transition: filter 0.2s;

    background-color: var(--blue00);
    color: #fff;
    font-size: 1.5rem;

    &:hover{
      filter: brightness(1.2);
    }
  }
`
